import { ChangeDetectionStrategy, Component, forwardRef, Input } from '@angular/core';
import { CommonStandaloneModule } from '../../../shared/common-standalone.module';
import { SHEPHERD_CARD_TYPES } from '../../model';

@Component({
  selector: 'app-shepherd-card',
  templateUrl: './shepherd-card.component.html',
  styleUrls: ['./shepherd-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [forwardRef(() => CommonStandaloneModule)],
})
export class ShepherdCardComponent {
  SHEPHERD_CARD_TYPES = SHEPHERD_CARD_TYPES;
  @Input() type: SHEPHERD_CARD_TYPES = SHEPHERD_CARD_TYPES.GRID;
}
